import { render, staticRenderFns } from "./isMyDataPrivateCard.vue?vue&type=template&id=76c149c4&scoped=true&"
import script from "./isMyDataPrivateCard.vue?vue&type=script&lang=js&"
export * from "./isMyDataPrivateCard.vue?vue&type=script&lang=js&"
import style0 from "./isMyDataPrivateCard.vue?vue&type=style&index=0&id=76c149c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c149c4",
  null
  
)

export default component.exports